module.exports = __webpack_public_path__ + "img/36.2757e65d.svg";